import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 12.77H12.77V18H11.23V12.77H6V11.23H11.23V6H12.77V11.23H18V12.77Z" fill={ fill || 'currentColor' } />
    </svg>
);
